
import React, { useState, useEffect } from 'react'
import { API_BASE_URL, GET_CONSOLIDATED_INDENTS } from '../../..//Config';
import Axios from "axios";
import { Link } from 'react-router-dom';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

const ViewConsolidatedIndents = () => {

    const [userDataSession, setUserDataSession] = useState([]);
    const [consolidatedIndednts, setConsolidatedIndents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);


    // #region Get Approved Indents
    useEffect(() => {
        if (userDataSession && userDataSession.OrgId) {
            setLoading(true);
            Axios.get(`${API_BASE_URL}${GET_CONSOLIDATED_INDENTS}?OrgId=${userDataSession.OrgId}`)
                .then((response) => {
                    setConsolidatedIndents(response.data.ResultData);
                    console.log(response.data.ResultData)
                    setLoading(false);
                })
                .catch((error) => {
                    setLoading(false);
                    console.error("Error fetching approved indents:", error);
                });
        }
    }, [userDataSession]);

    const handleSearchChange = (e) => {
        setSearchValue(e.target.value);
    };

    const filteredData = consolidatedIndednts && consolidatedIndednts.filter(item => 
        item.Product?.toLowerCase().includes(searchValue.toLowerCase())
    );

    const generatePDF = () => {
        const doc = new jsPDF();
    
        const tableColumn = ["#", "Product", "Requested Qty", "Approved Qty"];
    
        const tableRows = consolidatedIndednts.map((item, index) => [
            index + 1,
            item.Product,
            item.Qty,
            item.Approvedqty || 'N/A',
        ]);
    
        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 20,
            theme: 'grid',
        });
    
        doc.text("Consolidated Data", 14, 15);
    
        doc.save("ConsolidatedData.pdf");
    };

    const generateEXCEL = () => {
        const ws = XLSX.utils.json_to_sheet(consolidatedIndednts.map((item, index) => ({
            "#": index + 1,
            "Product": item.Product,
            "Requested Qty": item.Qty,
            "Approved Qty": item.Approvedqty || 'N/A',
        })));
    
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Consolidated Data");
    
        XLSX.writeFile(wb, "ConsolidatedData.xlsx");
    };

        return (
            <div>
                {/* view consolidated indents */}
                <div
                    className="offcanvas offcanvas-end"
                    tabIndex={-1}
                    id="offcanvasRight"
                    aria-labelledby="offcanvasRightLabel"
                    style={{ minWidth: "42%", maxWidth: '42%' }}
                >
                    <div className="offcanvas-header">
                        <h5 id="offcanvasRightLabel">Consolidated Indents</h5>
                        <button
                            type="button"
                            className="btn-close text-reset"
                            data-bs-dismiss="offcanvas"
                            aria-label="Close"
                        />
                    </div>{" "}
                    {/* end offcanvas-header*/}
                    <div className="offcanvas-body">
                        <div className="search-set ms-auto d-flex align-items-center justify-content-between">
                            <div className="search-input">
                                <input
                                    type="text"
                                    placeholder="Search"
                                    className="form-control form-control-sm formsearch"
                                    value={searchValue}
                                    onChange={handleSearchChange}
                                />
                                <Link to="#" className="btn btn-searchset">
                                    <i data-feather="search" className="feather-search" />
                                </Link>
                            </div>
                            <div className='d-flex '>
                                <div className='me-2'>
                                    <Link onClick={generatePDF} title='Download PDF'>
                                        <img src="assets/img/icons/pdf.svg" style={{ width: '1.4rem' }} alt="img" />
                                    </Link>
                                </div>
                                <div>
                                    <Link onClick={generateEXCEL} title='Download EXCEL'>
                                        <img src="assets/img/icons/excel.svg" style={{ width: '2rem' }} alt="img" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <table className="table datanew">
                            <thead className=''>
                                <tr>
                                    <th>#</th>
                                    {/* <th>Indent Number</th>
                                    <th>Store</th> */}
                                    <th>Product</th>
                                    <th>Requested Qty</th>
                                    <th>Approved Qty</th>
                                    {/* <th>Current Stock</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="12" className="text-center">
                                            <div className='loader m-auto'></div>
                                        </td>
                                    </tr>
                                ) : (
                                    filteredData?.length !== 0 ? (
                                        filteredData?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                {/* <td>{item.IndentNO}</td>
                                                <td>{item.Name}</td> */}
                                                <td>{item.Product}</td>
                                                <td className='text-info fw-bold'>{item.Qty}</td>
                                                <td className='text-success fw-bold'>{item.Approvedqty ? item.Approvedqty : '0'}</td>
                                                {/* <td>{item.CurrentStock}</td> */}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">No Data available</td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>     
                    </div>{" "}
                    {/* end offcanvas-body*/}
                </div>
                {/* view consolidated indents */}
            </div>
        )
}

export default ViewConsolidatedIndents
